module.exports = __webpack_public_path__ + "static/media/HLCA BYLAWS 2013.2e67bc42.pdf";